export default "__VITE_ASSET__CGJ$irm5__"